<script setup lang="ts">
import router from "@/router";
import { computed } from "vue";
import { RouterLink } from "vue-router";

const props = defineProps<{
  text?: string;
  icon: AwesomeIconName;
  badge?: string;
  link: string;
  iconColor?: string;
  selected?: boolean | "auto";
  direction?: "vertical" | "horizontal";
}>();

const isSelected = computed(() => {
  if (props.selected === "auto") {
    return router.currentRoute.value.path.startsWith(props.link);
  } else {
    return props.selected;
  }
});
</script>

<template>
  <div class="grow">
    <RouterLink :to="link">
      <div
        class="hover:bg-main-light bg-base-button flex items-center rounded-md transition-all duration-150"
        :class="[
          isSelected ? 'bg-main-light text-main' : '',
          props.direction === 'vertical'
            ? 'grow flex-col justify-center gap-0.5 py-1.5 pt-2 text-xs'
            : 'h-11 flex-row gap-3 px-4 text-sm',
        ]"
      >
        <span
          class="flex w-3 items-center justify-center"
          :class="[
            isSelected ? 'text-main' : (iconColor ?? 'text-main-text'),
            props.direction === 'vertical' ? 'text-xl' : 'text-lg',
          ]"
        >
          <i :class="'fa-solid fa-' + icon"></i>
        </span>
        <span class="">
          <slot>{{ text }}</slot>
        </span>
        <slot name="badge-wraper">
          <span
            v-if="badge !== undefined || $slots.badge !== undefined"
            class="ml-auto flex h-6 items-center justify-center rounded-full bg-gray-200 px-2 text-sm font-semibold text-gray-500"
          >
            <slot name="badge">{{ badge }}</slot>
          </span>
        </slot>
      </div>
    </RouterLink>
  </div>
</template>

<style scoped lang="scss"></style>
